import merge from 'lodash/merge';
import pick from 'lodash/pick';

const baseModel = {
  id: undefined,
  testCenterId: undefined,
  name: '',
  area: '',
  locationStatus:{
    status: 'OPEN',
  },
  statusDate: '',
  defaultCapacity: 0,
  address1: '',
  address2: '',
  address3: '',
  city: '',
  stateCode: '',
  postalCode: '',
  wheelChairFlag: true,
  tableFlag: true,
  payParkFlag: true,
  parkingFlag: true,
  otherFlag: true,
  lectureFlag: true,
  fullSurfaceFlag: true,
  classroomFlag: true,
  auditoriumFlag: true,
  airConditionFlag: true,
};

export default class LocationModel {
  constructor(data) {
    merge(this, baseModel, pick(data, Object.keys(baseModel)));
  }
}
